import { GET_MOSQUE_REQUESTS_REQUEST, GET_MOSQUE_REQUEST_BY_ID_REQUEST, UPDATE_MOSQUE_REQUEST_STATUS_REQUEST } from '../types/mosqueRequests'

export function getMosqueRequests(payload) {
  return {
    type: GET_MOSQUE_REQUESTS_REQUEST,
    payload,
  }
}

export function getMosqueRequestById(payload) {
  return {
    type: GET_MOSQUE_REQUEST_BY_ID_REQUEST,
    payload,
  }
}

export function updateMosqueRequestStatus(payload) {
  return {
    type: UPDATE_MOSQUE_REQUEST_STATUS_REQUEST,
    payload,
  }
}

